import { ContainerModule, interfaces } from 'inversify';
import { CreateDatasetService, ICreateDatasetService } from './createDataset.service';
import { CreateDatasetFilesService, ICreateDatasetFilesService } from './createDatasetFiles.service';
import { DatasetDraftsStore, IDatasetDraftsStore } from './datasetDrafts.store';
import { DatasetsService, IDatasetsService } from './datasets.service';
import { DatasetsStore, IDatasetsStore } from './datasets.store';
import { DatasetsDetailsStore, IDatasetsDetailsStore } from './datasetsDetails.store';
import { IImagesUploaderService, ImagesUploadService } from './imagesUpload.service';
import { IUpdateDatasetService, UpdateDatasetService } from './updateDataset.service';
import { IUpdateDatasetFilesService, UpdateDatasetFilesService } from './updateDatasetFiles.service';

export const datasetsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IImagesUploaderService.$).to(ImagesUploadService).inSingletonScope();
  bind(IDatasetsService.$).to(DatasetsService).inSingletonScope();
  bind(ICreateDatasetService.$).to(CreateDatasetService).inSingletonScope();
  bind(ICreateDatasetFilesService.$).to(CreateDatasetFilesService).inSingletonScope();
  bind(IUpdateDatasetService.$).to(UpdateDatasetService).inSingletonScope();
  bind(IUpdateDatasetFilesService.$).to(UpdateDatasetFilesService).inSingletonScope();
  bind(IDatasetsDetailsStore.$).to(DatasetsDetailsStore).inSingletonScope();
  bind(IDatasetsStore.$).to(DatasetsStore).inSingletonScope();
  bind(IDatasetDraftsStore.$).to(DatasetDraftsStore).inSingletonScope();
});
